import './bootstrap'
import '../css/app.css'

import {createApp, h} from 'vue'
import {createInertiaApp, router, usePage} from '@inertiajs/vue3'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import {createVuetify} from 'vuetify'
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers'
import {ZiggyVue} from '@/../../vendor/tightenco/ziggy'
import * as Sentry from '@sentry/vue'
import {notify} from "@/Services/useNotify.js"
import {Inertia} from "@inertiajs/inertia"

const appName = import.meta.env.VITE_APP_NAME || 'Laravel'

const vuetify = createVuetify({
    theme: {
        defaultTheme: 'dinamycTheme',
        themes: {
            dinamycTheme: {
                dark: false,
                colors: {
                    background: '#FFFFFF',
                    surface: '#FFFFFF',
                    'surface-bright': '#FFFFFF',
                    'surface-light': '#EEEEEE',
                    'surface-variant': '#424242',
                    'on-surface-variant': '#EEEEEE',
                    primary: portalOptions.primaryColor,
                    'primary-darken-1': '#1F5592',
                    headerTextColor: portalOptions.headerTextColor,
                    categoriesTextColor: portalOptions.categoriesTextColor,
                    secondary: portalOptions.secondaryColor,
                    'secondary-darken-1': '#018786',
                    error: '#B00020',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00',
                    institutionalGrey: '#474747',
                },
                variables: {
                    'border-color': '#000000',
                    'border-opacity': 0.12,
                    'high-emphasis-opacity': 0.87,
                    'medium-emphasis-opacity': 0.60,
                    'disabled-opacity': 0.38,
                    'idle-opacity': 0.04,
                    'hover-opacity': 0.04,
                    'focus-opacity': 0.12,
                    'selected-opacity': 0.08,
                    'activated-opacity': 0.12,
                    'pressed-opacity': 0.12,
                    'dragged-opacity': 0.08,
                    'theme-kbd': '#212529',
                    'theme-on-kbd': '#FFFFFF',
                    'theme-code': '#F5F5F5',
                    'theme-on-code': '#000000',
                }
            },
        },
    },
    defaults: {
        VSelect: {
            density: 'compact',
            variant: 'underlined',
            VLabel: {
                style: 'opacity: 0.87'
            }
        },
        VAutocomplete: {
            density: 'compact',
            variant: 'underlined',
            VLabel: {
                style: 'opacity: 0.87'
            }
        },
        VTextField: {
            density: 'compact',
            variant: 'underlined',
            VLabel: {
                style: 'opacity: 0.87'
            }
        },
        VFileInput: {
            density: 'compact',
            variant: 'underlined',
            VLabel: {
                style: 'opacity: 0.87'
            }
        },
        VTextarea: {
            density: 'compact',
            variant: 'underlined',
            VLabel: {
                style: 'opacity: 0.87'
            }
        },
        VRadioGroup: {
            density: 'comfortable',
            VLabel: {
                style: 'opacity: 0.87'
            }
        },
        VCheckbox: {
            density: 'comfortable',
            VLabel: {
                style: 'opacity: 0.87'
            }
        },
        VSwitch: {
            density: 'comfortable',
            color: 'blue-darken-1',
            VLabel: {
                style: 'opacity: 0.87'
            }
        }
    }
})

createInertiaApp({
    title: (title) => `${title} | ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({el, App, props, plugin}) {
        const app = createApp({render: () => h(App, props)})
        app.config.globalProperties.$route = route

        Sentry.init({
            app,
            dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
            beforeSend(event) {
                const userAgent = navigator.userAgent

                // ignora erros do bingbot
                if (userAgent.includes('bingbot')) {
                    return null
                }
                return event
            }
        })

        return app.use(plugin)
            .use(ZiggyVue)
            .use(vuetify)
            .mount(el)
    },

    progress: {
        color: '#4B5563',
    },
})

let isFirstLoad = true
router.on('navigate', (event) => {
        if (!isFirstLoad) {
            // precisa do timeout para deixar o componente carregar e atualizar o title no document
            setTimeout(() => {
                dataLayer.push({
                    event: 'page_view',
                    page_location: event.target.URL,
                    page_path: event.detail.page.url,
                    page_title: event.target.title
                })
            }, 100)
        }

        isFirstLoad = false
    }
)


router.on("finish", (event) => {
    const page = usePage()
    const notification = page.props?.flash?.notification

    if (notification && notification.message) {
        notify(notification.message, notification.color, notification)
    }
})
